import { useCallback, Ref, RefCallback, MutableRefObject } from 'react';

/**
 * Combines multiple refs (callback- or object-refs) into one.
 * Returns a stable callback ref that fans out the node to each.
 */
export const useMergeRefs = <T>(...refs: Array<Ref<T> | null | undefined>): RefCallback<T> =>
    useCallback((instance: T | null) => {
        refs.forEach((ref) => {
            if (typeof ref === 'function') {
                ref(instance);
            } else if (ref) {
                (ref as MutableRefObject<T | null>).current = instance;
            }
        });
        // refs is an array of parameters, but since it's not literal, eslint can't verify its correctness
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
